import "./App.css";
import Main from "./Components/Main";
import NavBarOne from "./Components/NavBarOne";
import NavBarTwo from "./Components/NavBarTwo";
import Stats from "./Components/Stats";
import Slides from "./Components/Slides";
import Cloud from "./Components/Cloud";
import Scale from "./Components/Scale";
import Features from "./Components/Features";
import Community from "./Components/Community";
import Footer from "./Components/Footer";

function App() {
  return (
    <>
      <NavBarOne />
      <NavBarTwo />
      <Main />
      <Stats />
      <Slides />
      <Cloud />
      <Scale />
      <Features />
      <Community />
      <Footer />
    </>
  );
}

export default App;
